import * as amplitude from '@amplitude/analytics-browser';

export const track = (event, eventProperties) => {
  if (ENV === 'production') {
    amplitude.track(event, eventProperties);
  } else {
    console.log({ event, eventProperties });
  }
};

export const chunkArray = (arr, chunkSize) => {
  const R = [];
  for (let i = 0, len = arr.length; i < len; i += chunkSize) R.push(arr.slice(i, i + chunkSize));
  return R;
};

export const getLoadSummary = (items) => items.reduce((summary, item) => {
  const { quantity } = item;
  const { mass } = item;
  const { length, width, height } = item.dimensions;
  const volume = length * width * height;

  const { type } = item;

  if (summary[type]) {
    summary[type].totalQuantity += quantity;
    summary[type].totalMass += mass;
    summary[type].totalVolume += volume;
  } else {
    summary[type] = {
      totalQuantity: quantity,
      totalMass: mass,
      totalVolume: volume,
    };
  }

  return summary;
}, {});

export const toReadableNumber = (number) => {
  // This utility will convert the number to the first non-zero number.
  if (number <= 0) {
    return number;
  }

  let i = 1;
  while (number < 10) {
    number *= 10;
    i *= 10;
  }
  return parseInt(number) / i;
};

export const textUtter = (text) => {
  const utter = new SpeechSynthesisUtterance();
  const voices = window.speechSynthesis.getVoices();
  utter.voice = voices[2];
  utter.volume = 1; // From 0 to 1
  utter.rate = 1; // From 0.1 to 10
  utter.pitch = 1; // From 0 to 2
  utter.text = text;
  speechSynthesis.cancel(); // to fix a bug on google chrome
  speechSynthesis.speak(utter);
};
